// extracted by mini-css-extract-plugin
export default {"list":"BalanceOfPayments_list__7w16s","row":"BalanceOfPayments_row__95VLs"};